import React , { Component } from 'react';
import { Row, Col, Card } from 'antd';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import ContactTable from'./ContactTable';
import './page-contact.less';

interface MyContactPageProps extends RouteComponentProps {
}

interface MyContactPageState {
    showAlert: boolean;
    alertMessage: string;
}

const STORAGE_KEYS = {
    MY_CONTACT_PAGE: 'myContactCurrentPage'
};

class MyContactPage extends Component<MyContactPageProps, MyContactPageState> {
    state = {
        showAlert: false,
        alertMessage: '',
    };

    async componentDidMount() {
        window.addEventListener('popstate', this.handlePopState);
        const currentPage = parseInt(localStorage.getItem(STORAGE_KEYS.MY_CONTACT_PAGE) || '1', 10);

        if (this.contactTableRef) {
            this.contactTableRef.setPaginationPage(currentPage);
        }

        this.getContactDataBasedOnEntry();
    }

    componentWillUnmount() {
        window.removeEventListener('popstate', this.handlePopState);
    }

    //监听浏览器返回事件
    handlePopState = () => {
        sessionStorage.setItem('isBackNavigation', 'true');
    };

    //确定进入方式，并获取数据
    getContactDataBasedOnEntry = () => {
        const isBack = sessionStorage.getItem('isBackNavigation') === 'true';
        const pageNo = isBack ? parseInt(localStorage.getItem(STORAGE_KEYS.MY_CONTACT_PAGE) || '1', 10) : 1;
    
        // 更新 localStorage
        localStorage.setItem(STORAGE_KEYS.MY_CONTACT_PAGE, pageNo.toString());
        sessionStorage.removeItem('isBackNavigation');
    
        if (!isBack) {
            // 通知 ContactTable 重置分页
            if (this.contactTableRef) {
                this.contactTableRef.setPaginationPage(1);
            }
        }
        // 让 ContactTable 组件加载数据
        this.contactTableRef.getContactTableData(pageNo);
    };

    contactTableRef: ContactTable;

    render() {
        return (
            <div>
                <BreadcrumbCustom breads={['我的', '我的沟通记录']} />
                <Card title="我的沟通记录" className="card-contact">
                    <Row>
                        <Col span={24}>
                            <ContactTable 
                                ref={ref => this.contactTableRef = ref}
                                company={null}
                                way={null}
                                customer={null}
                                beginTime={null}
                                endTime={null}
                                sales={null}
                                isMyContactContext
                            />
                        </Col>
                    </Row>
                </Card>
            </div>
        );
    }
}

export default withRouter(MyContactPage); 